module.exports = __webpack_public_path__ + "img/img3.6d178f59.jpg";